<template>
  <v-container fluid class="bg-accent">
    <!-- DESKTOP -->
    <div class="d-none d-lg-block">
      <v-row class="mx-16 px-16">
        <v-col cols="12">
          <span style="font-family: Montserrat !important;" class="text-white text-h1 font-weight-bold">
            {{ $t('you_arrived.title1') }}
          </span>
        </v-col>
      </v-row>
    </div>

    <!-- MOBILE -->
    <v-row class="d-lg-none">
      <v-col cols="12" class="text-center">
        <span style="font-family: Montserrat !important;" class="text-white text-h4 font-weight-bold">
          {{ $t('you_arrived.title1') }}
        </span>
      </v-col>
    </v-row>

    <!-- DESKTOP CARDS -->
    <div class="d-none d-lg-block">
      <v-row class="mx-16 px-16 py-16 mt-16 ma-0 pa-0" justify="center">
        <!-- Card 1 -->
        <v-col cols="12" md="3">
          <v-card color="primary" class="rounded-xl elevation-24 mx-2 px-2 fill-height">
            <v-card-title class="text-center">
              <v-icon color="white" size="90" icon="mdi-brain" />
            </v-card-title>
            <v-card-text class="text-center text-white text-h5 font-weight-bold text-decoration-underline">
              {{ $t('you_arrived.point1.title') }}
            </v-card-text>
            <v-card-text class="text-left text-white text-h6 font-weight-light">
              <v-row class="ma-0 pa-0" justify="center" v-for="i in 4" :key="'p1_'+i">
                <v-col cols="auto">
                  <v-icon size="15" color="white" icon="mdi-circle" class="mr-4" />
                </v-col>
                <v-col cols="8">
                  {{ $t('you_arrived.point1.tech' + i) }}
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Card 2 -->
        <v-col cols="12" md="3">
          <v-card color="primary" class="rounded-xl mx-2 px-2 fill-height">
            <v-card-title class="text-center">
              <v-icon color="white" size="90" icon="mdi-domain" />
            </v-card-title>
            <v-card-text class="text-center text-white text-h5 font-weight-bold text-decoration-underline">
              {{ $t('you_arrived.point2.title') }}
            </v-card-text>
            <v-card-text class="text-left text-white text-h6 font-weight-light">
              <v-row class="ma-0 pa-0" justify="center" v-for="i in 3" :key="'p2_'+i">
                <v-col cols="auto">
                  <v-icon size="15" color="white" icon="mdi-circle" class="mr-4" />
                </v-col>
                <v-col cols="8">
                  {{ $t('you_arrived.point2.tech' + i) }}
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Card 3 -->
        <v-col cols="12" md="3">
          <v-card color="primary" class="rounded-xl mx-2 px-2 fill-height">
            <v-card-title class="text-center">
              <v-icon color="white" size="90" icon="mdi-cog-box" />
            </v-card-title>
            <v-card-text class="text-center text-white text-h5 font-weight-bold text-decoration-underline">
              {{ $t('you_arrived.point3.title') }}
            </v-card-text>
            <v-card-text class="text-left text-white text-h6 font-weight-light">
              <v-row class="ma-0 pa-0" justify="center" v-for="i in 3" :key="'p3_'+i">
                <v-col cols="auto">
                  <v-icon size="15" color="white" icon="mdi-circle" class="mr-4" />
                </v-col>
                <v-col cols="8">
                  {{ $t('you_arrived.point3.tech' + i) }}
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Card 4 -->
        <v-col cols="12" md="3">
          <v-card color="primary" class="rounded-xl mx-2 px-2 fill-height">
            <v-card-title class="text-center">
              <v-icon color="white" size="90" icon="mdi-laptop" />
            </v-card-title>
            <v-card-text class="text-center text-white text-h5 font-weight-bold text-decoration-underline">
              {{ $t('you_arrived.point4.title') }}
            </v-card-text>
            <v-card-text class="text-left text-white text-h6 font-weight-light">
              <v-row class="ma-0 pa-0" justify="center">
                <v-col cols="auto">
                  <v-icon size="15" color="white" icon="mdi-circle" class="mr-4" />
                </v-col>
                <v-col cols="8">
                  {{ $t('you_arrived.point4.description') }}
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <!-- MOBILE CARDS -->
    <v-row class="d-lg-none mx-2 px-2 py-16" justify="center">
      <!-- Mobile Card 1 -->
      <v-col cols="12" class="mt-16">
        <v-card color="primary" class="rounded-xl elevation-24 fill-height">
          <v-card-title class="text-center">
            <v-icon color="white" size="75" icon="mdi-brain" />
          </v-card-title>
          <v-card-text class="text-center text-white text-h6 font-weight-bold text-decoration-underline">
            {{ $t('you_arrived.point1.title') }}
          </v-card-text>
          <v-card-text class="text-left text-white font-weight-medium">
            <v-row class="ma-0 pa-0" justify="center" v-for="i in 4" :key="'m1_'+i">
              <v-col cols="auto">
                <v-icon size="10" color="white" icon="mdi-circle" class="mr-4" />
              </v-col>
              <v-col cols="8">
                {{ $t('you_arrived.point1.tech' + i) }}
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Mobile Card 2 -->
      <v-col cols="12" class="mt-16">
        <v-card color="primary" class="rounded-xl elevation-24 fill-height">
          <v-card-title class="text-center">
            <v-icon color="white" size="75" icon="mdi-domain" />
          </v-card-title>
          <v-card-text class="text-center text-white text-h6 font-weight-bold text-decoration-underline">
            {{ $t('you_arrived.point2.title') }}
          </v-card-text>
          <v-card-text class="text-left text-white font-weight-medium">
            <v-row class="ma-0 pa-0" justify="center" v-for="i in 3" :key="'m2_'+i">
              <v-col cols="auto">
                <v-icon size="10" color="white" icon="mdi-circle" class="mr-4" />
              </v-col>
              <v-col cols="8">
                {{ $t('you_arrived.point2.tech' + i) }}
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Mobile Card 3 -->
      <v-col cols="12" class="mt-16">
        <v-card color="primary" class="rounded-xl elevation-24 fill-height">
          <v-card-title class="text-center">
            <v-icon color="white" size="75" icon="mdi-cog-box" />
          </v-card-title>
          <v-card-text class="text-center text-white text-h6 font-weight-bold text-decoration-underline">
            {{ $t('you_arrived.point3.title') }}
          </v-card-text>
          <v-card-text class="text-left text-white font-weight-medium">
            <v-row class="ma-0 pa-0" justify="center" v-for="i in 3" :key="'m3_'+i">
              <v-col cols="auto">
                <v-icon size="10" color="white" icon="mdi-circle" class="mr-4" />
              </v-col>
              <v-col cols="8">
                {{ $t('you_arrived.point3.tech' + i) }}
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Mobile Card 4 -->
      <v-col cols="12" class="mt-16">
        <v-card color="primary" class="rounded-xl elevation-24 fill-height">
          <v-card-title class="text-center">
            <v-icon color="white" size="75" icon="mdi-laptop" />
          </v-card-title>
          <v-card-text class="text-center text-white text-h6 font-weight-bold text-decoration-underline">
            {{ $t('you_arrived.point4.title') }}
          </v-card-text>
          <v-card-text class="text-left text-white font-weight-medium">
            <v-row class="ma-0 pa-0" justify="center">
              <v-col cols="auto">
                <v-icon size="10" color="white" icon="mdi-circle" class="mr-4" />
              </v-col>
              <v-col cols="8">
                {{ $t('you_arrived.point4.description') }}
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- DESKTOP MANAGEMENT -->
    <div class="d-none d-lg-block">
      <v-row class="py-16 ma-0 pa-0" justify="center">
        <v-col cols="12" class="mx-16 px-16 text-center">
          <span class="text-h2 text-warning font-weight-bold">{{ $t('you_arrived.management') }}</span>
        </v-col>
      </v-row>
    </div>

    <!-- MOBILE MANAGEMENT -->
    <v-row class="d-lg-none ma-0 pa-0" justify="center">
      <v-col cols="12" class="ma-2 pa-2 text-center">
        <span class="text-h4 text-warning font-weight-bold">{{ $t('you_arrived.management') }}</span>
      </v-col>
    </v-row>

    <!-- DESKTOP OFFER -->
    <div class="d-none d-lg-block">
      <v-row>
        <v-col cols="6">
          <div class="mx-16 px-16">
            <v-col cols="12">
              <span style="font-family: Montserrat !important;" class="text-white text-h2 font-weight-bold">
                {{ $t('you_arrived.offer.title') }}
              </span>
            </v-col>
            <v-col cols="12" class="py-6 mt-12">
              <v-icon color="white" icon="mdi-circle" class="mr-4" />
              <span class="text-white text-h4 font-weight-bold">
                {{ $t('you_arrived.offer.p1') }}
              </span>
            </v-col>
            <v-col cols="12" class="py-6">
              <v-icon color="white" icon="mdi-circle" class="mr-4" />
              <span class="text-white text-h4 font-weight-bold">
                {{ $t('you_arrived.offer.p2') }}
              </span>
            </v-col>
            <v-col cols="12" class="py-6">
              <v-icon color="white" icon="mdi-circle" class="mr-4" />
              <span class="text-white text-h4 font-weight-bold">
                {{ $t('you_arrived.offer.p3') }}
              </span>
            </v-col>
          </div>
        </v-col>
        <v-col cols="6" class="ma-0 pa-0">
          <div style="position: relative; top: -15%;" class="mt-n16">
            <v-img
              src="@/assets/texts/triangulo_texto.svg"
              lazy-src="@/assets/texts/triangulo_texto.svg"
              class="mt-n16"
              style="float: right; width: 80%; top: -15%;"
              cover
            />
          </div>
        </v-col>
      </v-row>
    </div>

    <!-- MOBILE OFFER -->
    <div class="d-lg-none mb-16">
      <v-row class="mt-8">
        <div style="display: block; margin: auto;">
          <v-col cols="12" class="text-center">
            <span style="font-family: Montserrat !important;" class="text-white text-h5 font-weight-bold">
              {{ $t('you_arrived.offer.title') }}
            </span>
          </v-col>
          <v-col cols="12" class="py-6 mt-12">
            <v-icon color="white" size="10" icon="mdi-circle" class="mr-4" />
            <span class="text-white font-weight-medium">
              {{ $t('you_arrived.offer.p1') }}
            </span>
          </v-col>
          <v-col cols="12" class="py-6">
            <v-icon size="10" color="white" icon="mdi-circle" class="mr-4" />
            <span class="text-white font-weight-medium">
              {{ $t('you_arrived.offer.p2') }}
            </span>
          </v-col>
          <v-col cols="12" class="py-6">
            <v-icon size="10" color="white" icon="mdi-circle" class="mr-4" />
            <span class="text-white font-weight-medium">
              {{ $t('you_arrived.offer.p3') }}
            </span>
          </v-col>
        </div>
      </v-row>
    </div>
  </v-container>
</template>

<script setup>
// sem lógica JS extra, só $t (vue-i18n)
</script>

<style>
.v-overlay__scrim {
  background-color: transparent !important;
  border-color: transparent !important;
}
</style>
